/* eslint-disable import/no-unresolved */
import {
  Table,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
  TableContainer,
  Box,
  Collapse,
  IconButton,
  Typography
} from '@material-ui/core';
import Scrollbar from 'src/components/Scrollbar';
import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import React, { useEffect, useState } from 'react';
import arrowIosUpwardFill from '@iconify/icons-eva/arrow-ios-upward-fill';
import editIcon from '@iconify/icons-eva/edit-fill';
import deleteIcon from '@iconify/icons-ic/round-delete-outline';
import arrowIosDownwardFill from '@iconify/icons-eva/arrow-ios-downward-fill';
import addRule from '@iconify/icons-eva/plus-circle-outline';
import { useDispatch, useSelector } from 'react-redux';
import {
  deleteExclusionRule,
  getExclusionRuleData,
  resetExclusionFileError,
  resetExclusionRuleSuccess
} from 'src/redux/slices/exclusionrules';
import { EXCLUSION_RULE_SET_LIST_HEAD, COLLAPSIBLE_EXCLUSION_RULE_SET_LIST_HEAD } from 'src/constants/Dashboard';
import { useSnackbar } from 'notistack5';
import Label from '../../Label';
import ExclusionRuleForm from './ExclusionRuleForm';
import ExclusionRuleDialog from './ExclusionRuleDialog';
import ExclusionRuleSetForm from './ExclusionRuleSetForm';

InnerTable.propTypes = {
  row: PropTypes.shape({
    date_added: PropTypes.string.isRequired,
    id: PropTypes.number,
    rules: PropTypes.array.isRequired,
    active: PropTypes.bool,
    exclusion_rule_name: PropTypes.string.isRequired
  }).isRequired,
  innerTableHead: PropTypes.array
};

export function InnerTable({ row, innerTableHead }) {
  const dispatch = useDispatch();
  let indexNumber = 0;

  const handleRuleDelete = (e, id) => {
    dispatch(deleteExclusionRule(id));
  };

  const [open, setOpen] = useState(false);

  return (
    <>
      <TableRow key={row.id}>
        <TableCell>
          <IconButton size="small" onClick={() => setOpen(!open)}>
            <Icon icon={open ? arrowIosUpwardFill : arrowIosDownwardFill} />
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row.exclusion_rule_name}
        </TableCell>
        <TableCell align="center">{row.rules.length}</TableCell>
        <TableCell align="center">{row.date_added}</TableCell>
        <TableCell align="center">
          {/* <Switch checked={row.active} /> */}
          <Label title={row.active ? 'Active' : 'In-Active'} color={row.active ? 'success' : 'warning'}>
            {row.active ? 'Active' : 'In-Active'}
          </Label>
        </TableCell>
        <TableCell align="center" title="Edit">
          <ExclusionRuleDialog
            dialogTitle="Edit Filtering Rule Set"
            ComponentCalled={ExclusionRuleSetForm}
            showbtnIcon
            editId={{ parentRuleId: row.id, name: row.exclusion_rule_name, status: row.active }}
          />
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6} sx={{ background: 'blanchedalmond' }}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box>
              <Table
                size="small"
                aria-label="purchases"
                sx={{
                  margin: 1
                }}
              >
                {row.rules.length !== 0 ? (
                  <>
                    <TableHead>
                      <TableRow>
                        <TableCell
                          align="center"
                          colSpan={innerTableHead.length - 1}
                          sx={{
                            background: 'blanchedalmond',
                            boxShadow: 'inset -8px 0 0 blanchedalmond !important;',
                            fontSize: '16px'
                          }}
                        >
                          Rule List
                        </TableCell>
                        <TableCell
                          align="right"
                          sx={{ background: 'blanchedalmond', boxShadow: 'inset -8px 0 0 blanchedalmond !important;' }}
                          title="Add Rule"
                        >
                          {/* {open && (
                            <ExclusionRuleDialog
                              dialogTitle="Add Exclusion Rule"
                              ComponentCalled={ExclusionRuleForm}
                              icon={addRule}
                              parentRuleId={row.id}
                            />
                          )} */}
                        </TableCell>
                      </TableRow>
                      {/* Collapsable Table Head Row */}
                      <TableRow>
                        {innerTableHead.map((headData) => (
                          <TableCell
                            sx={{
                              boxShadow: headData.id === 'no' || headData.id === 'action' ? 'none !important' : ''
                            }}
                            align={headData.align ? headData.align : 'center'}
                            key={headData.key}
                          >
                            {headData.label}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody sx={{ background: 'white' }}>
                      {row?.rules.map((nestedRowData, index) => (
                        <>
                          {index !== 0 && nestedRowData.rules.length !== 0 && (
                            <TableRow key={nestedRowData.id + 1}>
                              <TableCell
                                component="th"
                                scope="row"
                                align="center"
                                colSpan="5"
                                sx={{ fontWeight: 'bolder' }}
                              >
                                AND
                              </TableCell>
                            </TableRow>
                          )}
                          {nestedRowData?.rules.map((innerNestedRules, index) => {
                            indexNumber += 1;
                            return (
                              <>
                                {index !== 0 && (
                                  <TableRow key={nestedRowData.id} sx={{ background: 'aliceblue' }}>
                                    <TableCell
                                      component="th"
                                      scope="row"
                                      align="center"
                                      colSpan="5"
                                      sx={{ fontWeight: 'bolder' }}
                                    >
                                      OR
                                    </TableCell>
                                  </TableRow>
                                )}
                                <TableRow key={innerNestedRules.id} sx={{ background: 'aliceblue' }}>
                                  <TableCell>{indexNumber}</TableCell>
                                  <TableCell>{innerNestedRules.column_name}</TableCell>
                                  <TableCell align="center">{innerNestedRules.if_cell_value}</TableCell>
                                  <TableCell align="center">{innerNestedRules.value_or_text}</TableCell>
                                  <TableCell align="center">
                                    {/* editId=
                                    {{
                                      ruleId: nestedRowData.rule_collection_id,
                                      data: nestedRowData?.rules
                                    }} */}

                                    {index === 0 && (
                                      <>
                                        <ExclusionRuleDialog
                                          dialogTitle="Edit Filtering Rule"
                                          ComponentCalled={ExclusionRuleForm}
                                          icon={editIcon}
                                          showbtnIcon
                                          parentRuleId={row.id}
                                          editId={{
                                            ruleId: nestedRowData.rule_collection_id,
                                            data: nestedRowData?.rules
                                          }}
                                        />
                                        <IconButton
                                          size="small"
                                          title="Delete"
                                          onClick={(e) => {
                                            // setDeleteId(nestedRowData.id);
                                            handleRuleDelete(e, nestedRowData.rule_collection_id);
                                          }}
                                        >
                                          <Icon icon={deleteIcon} />
                                        </IconButton>
                                      </>
                                    )}
                                  </TableCell>
                                </TableRow>
                              </>
                            );
                          })}
                        </>
                      ))}
                    </TableBody>
                  </>
                ) : (
                  <TableRow
                  // style={{
                  //   height: (dense ? 33 : 53) * emptyRows
                  // }}
                  >
                    <TableCell colSpan={innerTableHead.length + 1} align="center">
                      <Typography gutterBottom align="center" variant="subtitle1">
                        No Data Found
                      </Typography>
                    </TableCell>

                    {/* {open && (
                      <TableCell align="right">
                        <ExclusionRuleDialog
                          dialogTitle="Add Exclusion Rule"
                          ComponentCalled={ExclusionRuleForm}
                          icon={addRule}
                          showbtnIcon
                          parentRuleId={row?.id}
                        />
                      </TableCell>
                    )} */}
                  </TableRow>
                )}
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}

CollapsableTable.propTypes = {};

export default function CollapsableTable() {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { exclusionRulesSetData, error, isError, success, isSuccess } = useSelector((state) => state.exclusionrules);

  useEffect(() => {
    if (isSuccess && success) {
      enqueueSnackbar(success, {
        variant: 'success'
      });
      dispatch(getExclusionRuleData());
      dispatch(resetExclusionRuleSuccess());
    } else if (isError && error) {
      enqueueSnackbar(error, {
        variant: 'error'
      });
      dispatch(resetExclusionFileError());
    }
  }, [isError, isSuccess]);

  useEffect(() => {
    dispatch(getExclusionRuleData());
  }, [dispatch]);

  console.log('exclusionRulesSetData', exclusionRulesSetData);

  return (
    <Scrollbar>
      <TableContainer sx={{ minWidth: 800, mt: 3 }}>
        <Table>
          {/* Main Table Head */}
          <TableHead>
            <TableRow>
              <TableCell />
              {EXCLUSION_RULE_SET_LIST_HEAD.map((headCell) => (
                <TableCell key={headCell.id} align={headCell.align ? headCell.align : 'center'}>
                  {headCell.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {exclusionRulesSetData.length > 0 ? (
              exclusionRulesSetData?.map((row) => (
                <InnerTable key={row.id} row={row} innerTableHead={COLLAPSIBLE_EXCLUSION_RULE_SET_LIST_HEAD} />
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={EXCLUSION_RULE_SET_LIST_HEAD.length + 1} align="center">
                  <Typography gutterBottom align="center" variant="subtitle1">
                    No Data Found
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Scrollbar>
  );
}
